import React, { useEffect } from "react";
import "./app.scss";
import "./App.css";
import "@repo/ui/src/styles/globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  ChakraProvider,
  withDefaultColorScheme,
  extendTheme,
} from "@chakra-ui/react";
import customTheme from "assets/customTheme";
import { appLogout, AuthContextProvider } from "./store/auth-context";
import { AppRoutes } from "./routes/routes";
import IdleManager from "components/IdleManager";

const queryClient = new QueryClient();
const theme = extendTheme(
  customTheme,
  withDefaultColorScheme({
    colorScheme: "primary",
  })
);
function App() {
  const channel = new BroadcastChannel("activityChannel");

  useEffect(() => {
    // Listen for logout events from IdleManager
    channel.onmessage = (event) => {
      if (event.data.type === "ALL_TABS_IDLE") {
        handleLogout();
      }
    };

    return () => {
      channel.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = () => {
    appLogout();

    // Add your logout logic here, e.g., clearing tokens, redirecting, etc.
    // eslint-disable-next-line no-console
    console.info("Logged out due to inactivity!");
  };

  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <AppRoutes />
          {/* <IdleManager /> */}
        </AuthContextProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
